module.exports = __webpack_public_path__ + "static/media/gitversion.7d358462.txt";


//////////////////
// WEBPACK FOOTER
// ./src/gitversion.txt
// module id = 2073
// module chunks = 0